export default [
  {
    title: 'Emails',
    route: 'Emails',
    icon: 'envelope',
    resource: 'Emails',
    action: 'manage',
  },
]
